function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState, useCallback, useEffect, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Popover, Icon } from 'mkui-fd';
var prefixCls = 'async-popover';

function AsyncPopover(props) {
  var content = props.content,
      children = props.children,
      title = props.title,
      api = props.api,
      params = props.params,
      rest = _objectWithoutProperties(props, ["content", "children", "title", "api", "params"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      visible = _useState8[0],
      setVisible = _useState8[1];

  useEffect(function () {
    if (visible && !loaded && api) {
      fetchData();
    }
  }, [visible]);
  var renderContent = useMemo(function () {
    if (loaded) {
      return React.createElement(content, {
        data: data
      }, null);
    }

    return React.createElement(Icon, {
      type: "loading",
      className: "".concat(prefixCls, "-loading")
    });
  }, [loading, loaded]);
  var visibleChangeHandle = useCallback(function (visible) {
    setVisible(visible);
  });
  var fetchData = useCallback(function () {
    setLoading(true);
    api(params).then(function (data) {
      setLoading(false);
      setData(data);
      setLoaded(true);
    });
  });
  return React.createElement(Popover, _extends({
    onVisibleChange: visibleChangeHandle,
    content: renderContent,
    title: title
  }, rest), children);
}

AsyncPopover.propTypes = {
  api: PropTypes.func,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.elements])
};
export default AsyncPopover;
//# sourceMappingURL=AsyncPopover.js.map
